import { Serializable } from '@/models/core/serializable';

export class Language implements Serializable<Language> {
  languageID: number;
  langCode: string;
  langName: string;
  dispName: string;
  nameOrder: boolean;

  deserialize(input: any) {
    this.languageID = input.languageID;
    this.langCode = input.code;
    this.langName = input.langName;
    this.dispName = input.dispName;
    this.nameOrder = input.nameOrder;
    return this;
  }

  get isNameOrder(): boolean {
    return this.nameOrder;
  }
}